<template>
    <modal v-if="popup_open && popup_name === 'invite_users'" modal_name="invite_users" type="medium" :title="!selecting_levels ? 'Invite users' : 'Add levels to invite'" :icon="!selecting_levels ? 'users' : 'layer-group'">
        <template v-slot:modal-content>
            <div class="modal-load-wrapper">
                <template v-if="!selecting_levels">
                    <inline-user-select :placeholder="$t('general.search_by_name')" v-model="invite_selected_users" :selected_users="allSelectedUsers" :level_user_ids="level_users" class="tw-mb-2"></inline-user-select>
					<div class="tw-mt-4 tw-ml-4 tw-text-sm">
						<p class="secondary-c hover-opacity" v-if="user.isAdmin && plugins.membership && plugins.membership === 'installed'" @click="openLevelSelect(true)">
							<i class="fal fa-plus tw-pr-1"></i>
							{{ $t('groups.invite_by_levels') }}
						</p>
						<p class="tw-mt-4 tw-pt-3 tw-text-red-600 tw-border-t tw-border-gray-100" v-if="tooManyInvites">
							{{ $t('events_and_groups.invite_limit_reached') }}
						</p>
					</div>
                </template>
                <template v-else>
                    <levels-list v-model="invite_levels" :display_explanation="false" :display_no_levels_message="false"></levels-list>
                </template>
            </div>
            <!--<div class="tw-mt-4" v-if="invite_selected_users.length > 0">
                <form-switch orientation="horizontal" :label="$t('events.notification_reaction_on_invite')" :helper="$t('events.get_notified_user_respond_invitation')" v-model="rsvp_type"></form-switch>
            </div>-->
        </template>
        <template v-slot:modal-bottom>
            <template v-if="!selecting_levels">
                <div class="subtle-button slim" @click="closePopup">
                    {{ $t('fields.cancel') }}
                </div>
                <div class="general-button btn-v2 slim" :class="{'tw-opacity-50 pointer-events-none': loading_users_for_levels || tooManyInvites}" @click="sendInvites">
                    {{ $t('groups.members_selected') }} ({{ inviteLevelCount }})
                    <i class="far fa-envelope" v-if="!loading_users_for_levels"></i>
                    <i class="far fa-spinner fa-spin" v-else></i>
                </div>
            </template>
            <template v-else>
                <div class="subtle-button slim" @click="openLevelSelect(false)">
                    {{ $t('groups.back_to_invite') }}
                </div>
                <div class="general-button btn-v2 slim" @click="addLevelsToInvite">
                    {{ $t('groups.add_to_list') }}
                    <i class="far fa-plus"></i>
                </div>
            </template>
        </template>
    </modal>
</template>

<script>
    import LevelsList from '../ui/LevelsList.vue';
    import InlineUserSelect from '../ui/input/InlineUserSelect.vue';
    import Global from '../../mixins/Global';
    import Modal from '../../mixins/v2/Modal';
    import Notification from '../../lib/models/Notification';

    export default {
        name: 'GroupsAndEventsInviteUsersModal',

        mixins: [Modal, Global],

        components: {
            'levels-list': LevelsList,
            'inline-user-select': InlineUserSelect,
        },

        props: {
            model_id: {
                required: true,
            },
            endpoint_name: {
                required: true,
                type: String,
            },
        },

        data() {
            return {
                invite_levels: [],
                selecting_levels: false,
                level_users: [],
                invite_selected_users: [],
                current_members: [],
                loading_users_for_levels: false,
                rsvp_type: true,
            };
        },

        computed: {
            allSelectedUsers() {
                return this.current_members.concat(this.invite_selected_users.map(user => user.id));
            },

            inviteLevelCount() {
                const concat_arr = this.level_users.concat(this.invite_selected_users);
                return Array.from(new Set(concat_arr)).length;            
            },

			tooManyInvites() {
				return this.inviteLevelCount > 5000;
			},
        },

        methods: {
            addLevelsToInvite() {
                this.level_users = [];
                this.loading_users_for_levels = true;

                let users_loaded_for_levels = 0;

                for (let i = 0; i < this.invite_levels.length; i += 1) {
                    axios.get(`/api/v3/levels/${this.invite_levels[i].level_id}/users`).then((response) => {
                        users_loaded_for_levels += 1;
                        this.level_users = this.level_users.concat(response.data);

                        if (users_loaded_for_levels === this.invite_levels.length) {
                            this.loading_users_for_levels = false;
                        }
                    });
                }

                this.openLevelSelect(false);
            },

            openLevelSelect(bool) {
                this.selecting_levels = bool;
            },

            sendInvites() {
                if (!this.loading_users_for_levels && !this.tooManyInvites) {
                    this.closePopup();

                    const user_ids = this.invite_selected_users.map(user => user.id);
                    const level_ids = this.invite_levels.map(level => level.level_id);

                    /*const request_body = {user_ids, level_ids};
                    if (this.rsvp_type === false) {
                        const rsvp_type = {
                            rsvp_type: 'noreply',
                        };

                        Object.assign(request_body, rsvp_type);
                    }*/

                    // axios.post(`/api/v3/${this.endpoint_name}/${this.model_id}/invite`, request_body).then(() => {
                    axios.post(`/api/v3/${this.endpoint_name}/${this.model_id}/invite`, { user_ids, level_ids }).then(() => {
                        Notification.insert({
                            data: [
                                {
                                    title: `<b>${this.invite_selected_users.length + this.level_users.length}</b> ${this.$t('groups.users_invited')}.`,
                                },
                            ],
                        });

                        this.invite_selected_users = [];
                    }).catch(() => {
                        Notification.insert({
                            data: [
                                {
                                    title: `${this.$t('groups.invites_could_not_be_send')}`,
                                    status: 'error',
                                },
                            ],
                        });
                    });
                }
            },
        },

        mounted() {
            axios.get(`/api/v3/${this.endpoint_name}/${this.model_id}/members/ids`).then((response) => {
                this.current_members = response.data;
            });
        },
    };
</script>
